import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_EVENT} from '../../metamodel/Concept';

export default class BusinessEventNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_EVENT;
	}
}
